const common = {
    action: "action",
    active: "active",
    active_non: "non active",
    add: "add",
    address: "address",
    approve: "approve",
    back: "back",
    batch: "tag",
    // brand: "brand",
    brand: "principal",
    category: "category",
    cancel: "cancel",
    chose: "chose",
    chose_img: "chose image",
    closing: "closing",
    company: "company",
    courier: "courier",
    customer: "customer",
    date: "date",
    date_start: "start date",
    date_end: "end date",
    date_range: "date range",
    date_update: "updated date",
    delete: "delete",
    detail: 'details',
    description: "description",
    discount: "discount",
    difference: "selisih",
    duplicate: 'duplicate',
    edit: "edit",
    email: "E-mail",
    export_excel: "eksport to excel",
    export_csv: "eksport to CSV",
    export_pdf: "eksport to PDF",
    finish: "finish",
    fullname: "full name",
    goods: "goods",
    height: "height",
    history: "history",
    image: "image",
    info: "information",
    language: "language",
    loading: "loading...",
    location: "location",
    length: "length",
    name: "name",
    name_full: "full name",
    next_month: "next month",
    no: "Number",
    note: "note",
    no_option: "no option",
    no_description: "no description",
    pass: "password",
    pass_conf: "confirmation password",
    pass_new: "new password",
    pass_reset: "reset password",
    pass_change: "change password",
    phone: "phone",
    prev_month: "previous month",
    price: "price",
    price_buy: "purchase price",
    price_sell: "selling price",
    price_retail: "retail price",
    print: "print",
    process: "process",
    profile: "profile",
    product: "product",
    quantity: "quantity",
    quantity_sell: "sold quantity",
    reject: "reject",
    reference: "reference",
    request: "request",
    sales: "sales",
    save: "save data",
    search: "search",
    serial_num: "serial number",
    sku: "SKU",
    supplier: "supplier",
    status: "status",
    stock: "stock",
    telp: "phone",
    unit: "unit",
    upload: "upload",
    user: "user",
    warehouse: "warehouse",
    weight: "weight",
    width: "width",
    verification: "verification",
}

export default common